export { mixpanel } from './mixpanel'

// Hooks
export { useMixpanel } from './hooks/useMixpanel'
export { useIdentifyUser } from './hooks/useIdentifyUser'
export { useWindowFocusTracking } from './hooks/useWindowFocusTracking'
export {
  trackEvent,
  startTimer,
  registerThemeProperty,
  unregisterRoleProperties,
} from './useAnalytics'

// Components
export { ThemeAnalytics } from './components/ThemeAnalytics'
export { UserAnalytics } from './components/UserAnalytics'

// Types
export type { MixpanelEvents } from './types/playerEvents'
export {
  AnalyticsScreen,
  ClipLoaderEvents,
  PlayerEvents,
} from './types/playerEvents'
export {
  BUTTON_PRESS,
  TAB_PRESS,
  VIEW,
  PAGE_LOAD,
  TOGGLE,
  SEARCH,
  SCROLL,
  UP,
  DOWN,
  CLICK,
  MAP_MOVE,
} from './types/baseEvents'
export {
  GTZ_ENTER,
  GTZ_RUN_TEST,
  GTZ_SAVE_GRID,
  GTZ_JOB_COMPLETED,
  GTZ_JOB_FAILED,
} from './types/gridTestingZoneEvents'
export {
  PROGRAM_RECOMMENDATIONS_PAGE_VIEW,
  PROGRAM_RECOMMENDATIONS_ACCEPT,
  PROGRAM_RECOMMENDATIONS_CONFIRM_ACCEPT,
  PROGRAM_RECOMMENDATIONS_REJECT,
  PROGRAM_RECOMMENDATIONS_CONFIRM_REJECT,
  PROGRAM_RECOMMENDATIONS_COMPLETE,
  PROGRAM_RECOMMENDATIONS_ARCHIVE,
  PROGRAM_RECOMMENDATIONS_PUBLISH,
} from './types/programRecommendationsEvents'
export {
  LABEL_SETTINGS_VIEW,
  LABEL_SETTINGS_OPEN_CREATE,
  LABEL_SETTINGS_SHOW_DISABLED,
  LABEL_SETTINGS_CLICK_RENAME,
  LABEL_SETTINGS_CLICK_REMOVE,
  LABEL_SETTINGS_RENAME_CONFIRM,
  LABEL_SETTINGS_RENAME_CANCEL,
  LABEL_SETTINGS_DISABLE_MODAL_SHOWN,
  LABEL_SETTINGS_DUPLICATE_WARNING_SHOWN,
  LABEL_WARNING_TOO_LONG,
  LABEL_WARNING_MAX_LENGTH,
  LABEL_SETTINGS_CREATE_SUCCESS,
  LABEL_SETTINGS_CREATE_FAILURE,
  LABEL_SETTINGS_RENAME_SUCCESS,
  LABEL_SETTINGS_RENAME_FAILURE,
  LABEL_SETTINGS_DISABLE_SUCCESS,
  LABEL_SETTINGS_DISABLE_FAILURE,
  LABEL_DEVICE_DRAWER_OPEN_PICKER,
  LABEL_DEVICE_DRAWER_ADD_SUCCESS,
  LABEL_DEVICE_DRAWER_ADD_FAILURE,
  LABEL_DEVICE_DRAWER_CREATE_SUCCESS,
  LABEL_DEVICE_DRAWER_CREATE_FAILURE,
  LABEL_DEVICE_DRAWER_REMOVE_SUCCESS,
  LABEL_DEVICE_DRAWER_REMOVE_FAILURE,
} from './types/labelEvents'
export {
  DEVICES_BULK_SELECT_DEVICE,
  DEVICES_BULK_SELECT_ALL,
  DEVICES_BULK_CLEAR_SELECTION,
  DEVICES_BULK_LABEL_OPEN,
  DEVICES_BULK_LABEL_SELECT_INTENT,
  DEVICES_BULK_LABEL_APPLY_SUCCESS,
  DEVICES_BULK_LABEL_APPLY_FAILURE,
  DEVICES_BULK_NON_CAMERA_SELECTION_ERROR,
  DEVICES_BULK_STREAM_ACCOUNT_OPEN,
  DEVICES_BULK_STREAM_ACCOUNT_APPLY_SUCCESS,
  DEVICES_BULK_STREAM_ACCOUNT_APPLY_FAILURE,
  DEVICES_BULK_DELETE_OPEN,
  DEVICES_BULK_DELETE_CONFIRM,
  DEVICES_BULK_DELETE_CANCEL,
  DEVICES_BULK_DELETE_SUCCESS,
  DEVICES_BULK_DELETE_FAILURE,
} from './types/deviceBulkEvents'
export {
  REASONING_TRAIL_CRITERION_TOGGLE,
  REASONING_TRAIL_ACCESS_LOGS_LINK,
  REASONING_TRAIL_FEEDBACK_THUMB,
  REASONING_TRAIL_FEEDBACK_COMMENT,
} from './types/reasoningTrailEvents'
export {
  SEND_TO_ONTIC_BUTTON_PRESS,
  SEND_TO_ONTIC_DISABLED_TOOLTIP_SHOWN,
  SEND_TO_ONTIC_SUCCESS,
  SEND_TO_ONTIC_FAILURE,
} from './types/onticEvents'
export { DISPATCH_NO_AVAILABLE_GUARDS_ALERT_SHOWN } from './types/dispatchEvents'
export { AI_INCIDENT_SUMMARY_BUTTON_PRESS } from './types/incidentSummaryEvents'
export {
  GUARD_ACTIVITY_FILTERS_APPLIED,
  GUARD_ACTIVITY_GUARD_ROW_BUTTON_PRESS,
  GUARD_DETAIL_DRAWER_CLOSE_BUTTON_PRESS,
  GUARD_DETAIL_DRAWER_FEED_FILTER_BUTTON_PRESS,
  GUARD_DETAIL_DRAWER_INCIDENT_ROW_BUTTON_PRESS,
  GUARD_DETAIL_DRAWER_TOUR_ROW_BUTTON_PRESS,
  GUARD_REPORT_DOWNLOAD_PDF_BUTTON_PRESS,
} from './types/guardActivityEvents'
export {
  QUICK_REPORT_DOWNLOAD_QR,
  QUICK_REPORT_DOWNLOAD_FACILITY_QR,
} from './types/quickReportEvents'
export {
  GLOBAL_MAP_MOVE,
  GLOBAL_MAP_CLUSTER_CLICK,
  GLOBAL_MAP_CLUSTER_RIGHT_CLICK,
  GLOBAL_MAP_FACILITY_MARKER_CLICK,
  GLOBAL_MAP_INCIDENT_MARKER_CLICK,
  GLOBAL_MAP_CIRCULAR_MENU_ITEM_CLICK,
} from './types/globalMapEvents'
